import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/services/auth/auth.api';
import { startSession } from '@/services/auth/session';
import type { ApiError } from '@/services/http/api-error';
import type { AuthSession, LoginRequest } from '@/types/auth';

export interface LoginInput extends LoginRequest {
  remember: boolean;
}

/**
 * Signs in and stores the session. No navigation here: GuestRoute redirects as soon as the
 * store turns `authenticated`, so there is exactly one redirect.
 */
export function useLogin() {
  return useMutation<AuthSession, ApiError, LoginInput>({
    mutationFn: ({ remember, ...body }) => authApi.login({ ...body, rememberMe: remember }),
    onSuccess: (session, { remember }) => startSession(session, remember),
    meta: { invalidates: false },
  });
}
